import React from 'react';

import { Link } from '~/lib/react-router-dom';

import { Box, Button, Grid, Stack, Typography } from '@mui/material';

import { CampaignCase } from './types';

interface Props {
  caseItem: CampaignCase;
  caseHref: string;
}

const EMPTY_VALUE = '-';

interface DetailEntry {
  label: string;
  value: string;
}

export default function CaseExpandedDetails({ caseItem, caseHref }: Props) {
  const entries: Array<DetailEntry> = [
    { label: 'Case Number', value: caseItem.number },
    { label: 'Status', value: caseItem.status },
    { label: 'Priority', value: caseItem.priority },
    { label: 'Case Record Type', value: caseItem.recordType },
    { label: 'Case Owner', value: caseItem.owner },
    { label: 'Original Case Owner', value: caseItem.originalOwner },
    { label: 'Opportunity', value: caseItem.opportunity },
    { label: 'Contact Account Name', value: caseItem.contactAccount },
    { label: 'Customers Email', value: caseItem.email },
    { label: 'Date/Time Opened', value: caseItem.opened },
    { label: 'Case Last Modified Date', value: caseItem.lastModified },
    { label: 'Booking Check-In Date', value: caseItem.checkIn },
    { label: 'Case Origin', value: caseItem.origin },
    { label: 'Case Reason', value: caseItem.reason },
    { label: 'Zendesk Id', value: caseItem.zendeskId },
  ];

  return (
    <Box sx={{ p: 2, bgcolor: 'action.hover' }}>
      <Stack spacing={2}>
        <Box>
          <Typography variant="caption" color="text.secondary" display="block">
            Subject
          </Typography>
          <Typography variant="body2" sx={{ overflowWrap: 'anywhere' }}>
            {caseItem.subject}
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {entries.map((entry) => (
            <Grid key={entry.label} size={{ xs: 6, md: 4, lg: 3 }}>
              <Typography variant="caption" color="text.secondary" display="block">
                {entry.label}
              </Typography>
              <Typography variant="body2" sx={{ overflowWrap: 'anywhere' }}>
                {entry.value || EMPTY_VALUE}
              </Typography>
            </Grid>
          ))}
        </Grid>
        <Box>
          <Typography variant="caption" color="text.secondary" display="block">
            Short Detail
          </Typography>
          <Typography variant="body2" sx={{ overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' }}>
            {caseItem.shortDetail || EMPTY_VALUE}
          </Typography>
        </Box>
        <Box>
          <Button component={Link} to={caseHref} size="small" variant="outlined" sx={{ textTransform: 'none' }}>
            Open case
          </Button>
        </Box>
      </Stack>
    </Box>
  );
}
